import debug from 'debug';

const log = debug('cartsee:shoplazza:newsletter');

export const shoplazzaNewsletter = () => {
  log('shoplazzaNewsletter');
};
